import React from 'react'

export const massachusettsSetupVars = {
  siteId: 'massachusetts',
  pathPrefix: '/ma',
  menuHeader: "Discover Massachusetts's Solution for:",
  appUrl: 'https://ma.headed2.com',
  logoImg: '/images/assets/massachusetts/horizontal/dark.svg',
  headerTitle: `The Massachusetts CareerExplorer is a system designed for Massachusetts`
}
